import React from "react"
import { Switch, Route, Redirect, useLocation } from "react-router-dom"
import Home from "./Pages/Home"
import ErrorPage from "./Pages/404"
import AuthFail from "./Pages/AuthFail"
import Maintain from "./Pages/Ｍaintain"

const Config = () => {
  const query = useLocation().search
  return (
    <Switch>
      <Redirect exact from="/" to={`/Home${query}`} />
      <Route path="/Home" exact component={Home} />
      <Route path="/ErrorPage" exact component={ErrorPage} />
      <Route path="/AuthFail" exact component={AuthFail} />
      <Route path="/Maintain" exact component={Maintain} />
      <Redirect to={`/ErrorPage${query}`} />
    </Switch>
  )
}

export default () => {
  return <Config />
}
